import type { RequestProductsActionProductsPayload } from 'src/redux/products/types';
import type { Product } from 'src/redux/products/types/Product';
import type { BrowseDataAPIResponseBody } from 'src/services/browse-data-api/types/BrowseDataAPIResponseBody';

export const adaptBrowseProducts = (
  browseServiceProductsData: BrowseDataAPIResponseBody,
): RequestProductsActionProductsPayload => {
  const {
    attributionToken,
    category,
    currencyCode,
    currentPage,
    navigation,
    partner,
    perPage,
    pinnedResultCount,
    products,
    productsReturnedCount,
    providerMetadata,
    queryType,
    term,
    totalPages,
    totalProducts,
    zeroExactResults,
  } = browseServiceProductsData;

  return {
    category: category
      ? {
          baseType: category.baseType,
          hierarchy: category.hierarchy,
          name: category.name,
          seoCategories: category.seoCategories,
        }
      : null,
    currencyCode,
    products: products.map((product) => {
      const {
        images,
        isSponsored,
        links,
        lowCommitmentProductFlag,
        lowCommitmentProductType,
        number_of_reviews,
        product_rating,
        ...restOfProduct
      } = product;

      return {
        ...restOfProduct,
        detailPageHref: links?.[0]?.rel || '',
        imageSrc: images?.[0]?.href || '',
      } as Product;
    }),
    perPage,
    lastPageLoaded: currentPage,
    totalPages,
    totalProducts,
    productsReturnedCount,
    queryType,
    term,
    navigation,
    partner,
    providerAttributionToken: attributionToken || null,
    zeroExactResults,
    pinnedResultCount,
    providerMetadata,
  };
};
